<template>
  <div>
    <v-card class="member-card gold-gradient rounded-xl overflow-hidden pa-4" elevation="15" @click="dialog = true" v-ripple>
      <div class="card-shine"></div>

      <div class="d-flex justify-space-between align-center relative z-index-2">
        <div>
          <span class="caption white--text font-weight-bold text-uppercase letter-spacing-2">Dein Test-Pass</span>
          <h3 class="text-h6 font-weight-black white--text mt-1">MEMBERCARD</h3>

          <div class="d-flex align-center mt-2">
            <v-icon small color="white" class="mr-1">mdi-timer-sand</v-icon>
            <span class="font-weight-bold white--text"> {{ daysLeft }} {{ daysLeft === 1 ? "Tag" : "Tage" }} übrig </span>
          </div>
        </div>

        <div class="balance-circle-gold">
          <v-icon color="white" size="28">mdi-ticket-percent-outline</v-icon>
        </div>
      </div>

      <v-progress-linear :value="progress" color="white" background-color="rgba(255,255,255,0.3)" height="6" rounded class="mt-4"></v-progress-linear>
    </v-card>

    <v-dialog v-model="dialog" max-width="450" content-class="member-dialog rounded-xl">
      <v-card class="gold-dialog-bg white--text rounded-xl">
        <v-card-text class="text-center mt-3 white--text px-6">
          <h2 class="text-h5 font-weight-black mb-1">Hallo {{ firstName }}!</h2>
          <div class="caption white--text opacity-70 mb-4">{{ email }}</div>

          <div class="status-box pa-3 rounded-lg mb-6">
            <div class="d-flex justify-space-between align-center mb-1">
              <span class="caption font-weight-bold text-uppercase opacity-80">Gültig bis</span>
              <span class="font-weight-bold">{{ formattedEndDate }}</span>
            </div>
            <v-progress-linear :value="progress" color="primary" background-color="rgba(255,255,255,0.2)" height="6" rounded></v-progress-linear>
            <div class="text-right mt-1">
              <small class="white--text font-weight-bold">{{ daysLeft }} Tage verbleibend</small>
            </div>
          </div>

          <div class="info-text mb-6">
            <h4 class="font-weight-bold mb-2 text-uppercase" style="letter-spacing: 1px">Dein Zugang zum Training</h4>
            <p class="body-2 opacity-90" style="line-height: 1.6">
              Mit dieser Membercard kannst du unser gesamtes <strong>Fitness- und Groupfitness-Angebot</strong> unbegrenzt nutzen. <br /><br />
              <v-icon small color="white" class="mr-1">mdi-check-circle</v-icon> Zeige diesen Pass einfach beim Check-in an der Theke vor.
              <br />
              <v-icon small color="white" class="mr-1">mdi-clock-outline</v-icon> Gültig während der betreuten Öffnungszeiten.
            </p>
          </div>
        </v-card-text>

        <v-card-actions class="pb-6 px-6">
          <v-btn block x-large rounded color="primary" class="font-weight-bold" @click="dialog = false"> Alles klar, let's go! 🚀 </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment"

export default {
  name: "membercard",
  props: {
    membercard: {
      type: Object,
      required: true,
    },
    firstName: {
      type: String,
      default: "",
    },
    email: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      dialog: false,
    }
  },
  created() {
    // Wenn die Karte aktiv ist, sagen wir dem Home-Screen, dass er das normale Training ausblenden soll
    // (Logik aus der alten membercard.vue übernommen)
    if (this.isActive) {
      this.$emit("hideTraining")
    }
  },
  computed: {
    isActive() {
      return this.membercard && this.membercard.isActive && moment().isBefore(moment(this.membercard.endDate))
    },
    formattedEndDate() {
      if (!this.membercard || !this.membercard.endDate) return "-"
      return moment(this.membercard.endDate).format("DD.MM.YYYY")
    },
    daysLeft() {
      if (!this.membercard || !this.membercard.endDate) return 0
      const endDate = new Date(this.membercard.endDate)
      const now = new Date()
      const diffTime = endDate - now
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
      return diffDays > 0 ? diffDays : 0
    },
    progress() {
      // Standardmässig 11 Tage Laufzeit annehmen
      const maxDays = 11
      const current = Math.min(this.daysLeft, maxDays)
      return (current / maxDays) * 100
    },
  },
}
</script>

<style lang="scss" scoped>
/* Karte & Gradient */
.gold-gradient {
  background: linear-gradient(135deg, #f9a825 0%, #fbc02d 50%, #ff6f00 100%);
  position: relative;
  transition: transform 0.2s;
}
.gold-gradient:active {
  transform: scale(0.98);
}
.card-shine {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, transparent 50%);
  pointer-events: none;
  z-index: 1;
}
.balance-circle-gold {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 15px rgba(255, 255, 255, 0.4);
}

/* Dialog Styles */
.gold-dialog-bg {
  background: linear-gradient(160deg, #212121 0%, #000000 100%);
  border: 1px solid rgba(251, 192, 45, 0.3);
}
.gold-avatar-border {
  border: 3px solid #fbc02d;
  box-shadow: 0 0 20px rgba(251, 192, 45, 0.3);
}
.status-box {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

/* Utilities */
.letter-spacing-2 {
  letter-spacing: 2px;
}
.z-index-2 {
  z-index: 2;
  position: relative;
}
.opacity-70 {
  opacity: 0.7;
}
.opacity-80 {
  opacity: 0.8;
}
.opacity-90 {
  opacity: 0.9;
}

/* Dialog Content Class Override */
::v-deep .member-dialog {
  overflow: visible;
}
</style>
